import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
// https://github.com/ReactTraining/react-router/issues/4694
// For ConnectedRouter, use
// npm install react-router-redux@next
import { ConnectedRouter } from 'react-router-redux'
import APP from '../containers/APP'
import Routes from '../routes/routes'
//import { Router} from 'react-router'
// https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#sampleRate
// https://web-design-weekly.com/2016/07/08/adding-google-analytics-react-application/
export default class Root extends React.Component {
  render() {
    const { history, store } = this.props;
    //console.log(history);
    //console.log(store);
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <APP>
            <Routes/>
          </APP>     
        </ConnectedRouter> 
      </Provider>
    )
  }
}
Root.propTypes = {
  history: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired
}
/*
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <div>
             Hello
          </div>
        </ConnectedRouter> 
      </Provider>
  */


// WEBPACK FOOTER //
// ./src/containers/Root.js